module.exports = __webpack_public_path__ + "img/linkedin.86e23144.png";